import { Component } from '@angular/core';
import { FormBuilder, Validators } from "@angular/forms";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { UserApi } from '../../../shared/sdk';
// import { Funciones } from "../../../shared/funciones";

import * as _ from 'lodash';
declare let window: any;

@Component({
  selector: 'reset-f-modal-page',
  templateUrl: './reset-f-modal.component.html'
})
export class FrontResetPasswordModalComponent {

  public invalidForm: boolean = false;
  public registerForm: boolean = false;
  public captchaValue: String;

  public resetForm = this.fb.group({
    email: ['', [Validators.email]],
  });

  constructor(
    public activeModal: NgbActiveModal,
    public fb: FormBuilder,
    public userapi: UserApi
  ) { }

  reiniciar(e: any) {
    if (this.resetForm.valid && this.captchaValue) {
      const url = `${window.location.protocol}//${window.location.host}/login/reset-password/`;
      this.userapi.resPassword(this.resetForm.value.email, this.captchaValue, url).subscribe(() => {
        this.activeModal.close();
      }, () => {
        this.activeModal.close();
      });
    } else {
      this.invalidForm = true;
    }
  }

  handleCorrectCaptcha(e) {
    this.captchaValue = e;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/frontend/login/reset-f-modal.component.ts